import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItem } from '@mui/material';
import classNames from 'classnames';
import { Children, isValidElement, useState } from 'react';
import styles from './VerticalTabs.module.scss';
export const VerticalTab = ({ children }) => {
    return children;
};
export const VerticalTabs = ({ children }) => {
    // make sure children are VerticalTab components
    const tabs = Children.toArray(children).filter(child => isValidElement(child) && child.type === VerticalTab);
    const [activeTab, setActiveTab] = useState(0);
    // get the titles from the children
    const titles = tabs.map(tab => tab.props.title);
    return (_jsx("div", { children: _jsxs("div", { className: styles.verticalTabs, children: [_jsx(List, { className: styles.menu, children: titles.map((title, index) => (_jsx(ListItem, { onClick: () => setActiveTab(index), className: classNames(styles.menuItem, index === activeTab && styles.selected), children: title }, title))) }), _jsx("div", { className: styles.content, children: tabs[activeTab]?.props?.children })] }) }));
};
